export const decodeJWT = (token: string): any => {
	try {
		const cleanToken = token.replace('Bearer ', '');

		const parts = cleanToken.split('.');

		if (parts.length !== 3) {
			throw new Error('Token JWT inválido');
		}

		const payload = parts[1];

		const paddedPayload = payload + '='.repeat((4 - (payload.length % 4)) % 4);

		const decodedPayload = atob(paddedPayload);

		return JSON.parse(decodedPayload);
	} catch (error) {
		console.error('Erro ao decodificar JWT:', error);
		return null;
	}
};

export const getTransportadoraId = (token: string): string | null => {
	const payload = decodeJWT(token);

	if (!payload) {
		return null;
	}

	return payload['UboiWeb.TransportadoraId'] || null;
};

export const hasOutsystemIntegrationAccess = (token: string): boolean => {
	const payload = decodeJWT(token);
	return payload?.['UboiWeb.OutsystemAccess'] === 'true';
};
